var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmarkX2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1977 5.28363C21.5934 5.66897 21.6017 6.30208 21.2164 6.69772L8.8125 19.4332L2.78363 13.2432C2.39829 12.8475 2.40664 12.2144 2.80228 11.8291C3.19792 11.4437 3.83103 11.4521 4.21637 11.8477L8.8125 16.5668L19.7836 5.30228C20.169 4.90664 20.8021 4.89829 21.1977 5.28363Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkX2);
export default __webpack_public_path__ + "static/media/CheckmarkX2.a02ad5e937d41cea01cf17ffd162febc.svg";
export { ForwardRef as ReactComponent };